export default __webpack_public_path__ + "static/media/error-404.a0b78605.svg";